import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import translations from './locales/en/translation.json';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(Backend)
  .init({
    resources: {
      en: {
        translation: translations
      }
    },
    lng: 'en',
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    react: {
      wait: true,
      transSupportBasicHtmlNodes: true
    }
  }).then(r => console.log('loaded', r));

export default i18n;
